var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecentralized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-decentralized-2030784",
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1277",
    "data-name": "Grupo 1277",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Decentralized"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_731",
    "data-name": "Caminho 731",
    d: "M32,43A11,11,0,1,1,43,32,11,11,0,0,1,32,43Zm0-20a9,9,0,1,0,9,9A9,9,0,0,0,32,23Z",
    transform: "translate(-6.5 -6.5)",
    fill: "#ccff1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_732",
    "data-name": "Caminho 732",
    d: "M12,57a5,5,0,1,1,5-5,5,5,0,0,1-5,5Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,12,49Z",
    transform: "translate(-7 -6)",
    fill: "#ccff1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_733",
    "data-name": "Caminho 733",
    d: "M48,53a5,5,0,1,1,5-5A5,5,0,0,1,48,53Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,48,45Z",
    transform: "translate(-6 -6)",
    fill: "#ccff1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_734",
    "data-name": "Caminho 734",
    d: "M32,37a5,5,0,1,1,5-5A5,5,0,0,1,32,37Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,32,29Z",
    transform: "translate(-6.5 -6.5)",
    fill: "#ccff1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_735",
    "data-name": "Caminho 735",
    d: "M52,17a5,5,0,1,1,5-5,5,5,0,0,1-5,5Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,52,9Z",
    transform: "translate(-6 -7)",
    fill: "#ccff1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_736",
    "data-name": "Caminho 736",
    d: "M16,21a5,5,0,1,1,5-5,5,5,0,0,1-5,5Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,16,13Z",
    transform: "translate(-7 -7)",
    fill: "#ccff1c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1350",
    "data-name": "Ret\\xE2ngulo 1350",
    width: 2,
    height: 8.49,
    transform: "translate(11.563 12.974) rotate(-45)",
    fill: "#ccff1c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1351",
    "data-name": "Ret\\xE2ngulo 1351",
    width: 14.14,
    height: 2,
    transform: "translate(32.299 17.292) rotate(-45)",
    fill: "#ccff1c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1352",
    "data-name": "Ret\\xE2ngulo 1352",
    width: 14.14,
    height: 2,
    transform: "translate(7.299 42.293) rotate(-45)",
    fill: "#ccff1c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1353",
    "data-name": "Ret\\xE2ngulo 1353",
    width: 2,
    height: 8.49,
    transform: "translate(32.027 33.444) rotate(-45)",
    fill: "#ccff1c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecentralized);
export default __webpack_public_path__ + "static/media/decentralized.a6d63fed3a77630a91cfa3f50c07c4be.svg";
export { ForwardRef as ReactComponent };